import { getNotificationStatus } from 'templates/Notificacoes/Body/Sections/Overview/notification.constants'

import { TimelineRecord, TimelineStatistics } from '../../types/invoiceTimeline'

export interface TimelineSummaryData {
  sent: number
  failed: number
  opened: number
}

/**
 * SC-10890: os três números do resumo saem dos dados que a timeline JÁ carregou.
 *
 * Nada de endpoint novo nem de segundo contador no backend: um total que diverge
 * da lista logo abaixo dele é pior que total nenhum, e é o que aconteceria se
 * estes números viessem de outra query.
 *
 * "Falhadas" usa o `tone: 'error'` do mapa da Central de Notificações, não uma
 * lista de status escrita aqui. São 12 status de erro hoje (bounced, undelivered,
 * blacklisted, no_phone, quota_exceeded...) e quem inventar o 13º acerta este
 * card de graça.
 *
 * Uma notificação falhada NÃO conta como enviada: o merchant precisa saber
 * quantas de fato saíram, e somar as duas colunas esconde justamente o problema
 * que ele abriu a tela para investigar.
 */
export const buildTimelineSummary = (
  records: TimelineRecord[] = [],
  statistics?: TimelineStatistics
): TimelineSummaryData => {
  const notifications = records.filter((r) => r.kind === 'notification')

  const failed = notifications.filter(
    (r) => getNotificationStatus(r.status || '', r.statusLabel).tone === 'error'
  ).length

  return {
    sent: notifications.length - failed,
    failed,
    // openCount vem do contador da cobrança, não de records.filter(kind==='open'):
    // cobrança anterior ao rastreamento por evento sabe QUANTAS vezes foi aberta
    // sem ter um evento por abertura (hasDetailedOpenHistory: false).
    opened: statistics?.openCount ?? 0
  }
}

export type TimelineFilter = 'sent' | 'failed' | 'opened'

/**
 * SC-10890: filtro da timeline pelos cards do resumo. Só no front, sobre os
 * registros já carregados — é recorte de leitura, não consulta nova.
 *
 * "Enviadas" e "falhas" partem da mesma regra do resumo (`tone: 'error'`), então
 * o que o card conta é exatamente o que a lista mostra ao ser clicado.
 */
export const filterRecords = (
  records: TimelineRecord[],
  filter: TimelineFilter | null
): TimelineRecord[] => {
  if (!filter) return records

  if (filter === 'opened') return records.filter((r) => r.kind === 'open')

  const notifications = records.filter((r) => r.kind === 'notification')

  return notifications.filter((r) => {
    const failed =
      getNotificationStatus(r.status || '', r.statusLabel).tone === 'error'

    return filter === 'failed' ? failed : !failed
  })
}
